import { categoryTags } from '@/mocks/home';

const progress = [
  { label: '2016—2020 早期存档补录', value: 78, tone: 'bg-primary-500' },
  { label: '往期截图高清修复', value: 54, tone: 'bg-accent-500' },
  { label: '旧采访文字稿校对', value: 63, tone: 'bg-secondary-500' },
];

export default function CategoryIndex() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1fr] lg:gap-14">
          <div>
            <span className="font-label text-xs tracking-[0.24em] text-secondary-700">
              INDEX / 栏目索引
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              所有栏目，一张表看全
            </h2>
            <p className="mt-3 font-body text-sm leading-7 text-foreground-600">
              下面这些是黑料社网目前开放的栏目与标签，后面的数字是对应已收录的条目数。
              翻旧账时按栏目找比按关键词瞎搜要准得多。
            </p>

            <div className="mt-7 space-y-4 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                <i className="ri-bar-chart-2-line text-primary-600"></i>
                存档整理进度
              </p>
              {progress.map((row) => (
                <div key={row.label}>
                  <div className="flex items-center justify-between font-label text-xs text-foreground-600">
                    <span>{row.label}</span>
                    <span>{row.value}%</span>
                  </div>
                  <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-300">
                    <div
                      className={`h-full rounded-full ${row.tone}`}
                      style={{ width: `${row.value}%` }}
                    ></div>
                  </div>
                </div>
              ))}
              <p className="pt-1 font-body text-xs leading-6 text-foreground-500">
                补录按季度推进，已完成的年份会在历史存档中标注「已归档」。
              </p>
            </div>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {categoryTags.map((tag) => (
                <a
                  key={tag.label}
                  href="#archive"
                  className="group flex cursor-pointer flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-400 hover:bg-secondary-50"
                >
                  <span className="font-heading text-sm font-bold text-foreground-900 transition-colors group-hover:text-secondary-900">
                    {tag.label}
                  </span>
                  <span className="mt-3 flex items-baseline gap-1">
                    <span className="font-heading text-lg font-black text-primary-600">
                      {tag.count}
                    </span>
                    <span className="font-label text-[11px] text-foreground-500">条</span>
                  </span>
                </a>
              ))}
            </div>

            <div className="mt-4 flex flex-col items-start justify-between gap-3 rounded-lg border border-primary-200 bg-primary-50 px-5 py-4 sm:flex-row sm:items-center">
              <p className="font-body text-sm leading-6 text-primary-900">
                没找到对应的栏目？可以提交一个新的存档方向。
              </p>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                提交栏目
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}